import { MapProps } from "types/estatesAndMap";

/** Collect the same map sources used by the sharing selector, once per map. */
export default function getEstateMaps(
  estateId: string,
  userMaps: Record<string, MapProps>,
  orgMaps: Record<string, MapProps>,
  teamMaps: Record<string, Record<string, MapProps>>,
): MapProps[] {
  const mapsById = new Map<string, MapProps>();
  const sources = [userMaps, orgMaps, ...Object.values(teamMaps)];
  sources.forEach((maps) => Object.values(maps).forEach((map) => {
    if (map.estateId === estateId && !mapsById.has(map.id)) mapsById.set(map.id, map);
  }));
  return [...mapsById.values()];
}
